import { Component, OnInit } from '@angular/core';
import {NavbarService} from '../../shared/services/navbar.service';
import {CountryGuideService} from '../../shared/services/countryGuide.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IWGSharedService } from '../../shared/services/shared.service';
@Component({
  selector: 'app-country-guide-detail',
  templateUrl: './country-guide-detail.component.html',
  styleUrls: ['./country-guide-detail.component.scss']
})
export class CountryGuideDetailComponent implements OnInit {

  countryGuideId: any;
  countryGuide: any;
  isLoading: false;
  id: number;
  regionId: 'null';
  showFooter = true
  constructor(
      public nav: NavbarService,
      public countryGuideService: CountryGuideService,
      public router: Router,
      public route: ActivatedRoute,
      private sharedService: IWGSharedService, 
  ) { }

  getCountryGuideDetail = () => {
    this.countryGuideService.getCountryGuidesDetail(this.countryGuideId, this.regionId)
        .subscribe(response => {
          this.countryGuide = response.data.Data;
        });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.countryGuideId = params.ID;
    });
     
     
      var isEmbed = this.sharedService.getIsEmbed();
      this.nav.show(isEmbed);
      if (isEmbed===true) {
          history.pushState(null, null, null);       
          window.addEventListener('popstate', () => {
              history.pushState(null, null, null);            
          });
        this.showFooter = false;
    }else{
        this.showFooter = true;
    }
    this.getCountryGuideDetail();
  }

}
